import React, { useState, useEffect, useRef } from 'react';
import CompEditProduct from './EditProducto';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useBeforeunload } from 'react-beforeunload';
import { FaTrashAlt, FaArrowUp, FaHeart, FaRegHeart } from 'react-icons/fa'; // Importa el ícono de la papelera
import { gsap } from 'gsap'; // Importa GSAP para animaciones


const CompInventario = () => {

  const [inventory, setInventory] = useState([]);
  const { token, userId } = useAuth();
  const [favoritos, setFavoritos] = useState([]); // <-- Favoritos actuales del user
  const [mostrarSoloFavoritos, setMostrarSoloFavoritos] = useState(false);

  const editProductRef = useRef({ hasUnsavedChanges: false });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [orderBy, setOrderBy] = useState("updatedAt");
  const [orderDirection, setOrderDirection] = useState("desc");
  const [searchTerm, setSearchTerm] = useState("");
  const editContainerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const fetchInventoryAndFavorites = async () => {
    setLoading(true);
    setError(null);
    try {
      const [productosResp, favoritosResp] = await Promise.all([
        axios.get(`${import.meta.env.VITE_API_URL}/productos/admin`, {
          params: { orderBy, orderDirection, searchTerm },
          headers: { 'x-auth-token': token },
        }),
        axios.get(`${import.meta.env.VITE_API_URL}/favoritos/${userId}`, {
          headers: { 'x-auth-token': token },
        }),
      ]);



      const idsFavoritos = favoritosResp.data.map(f => f.id);

      setInventory(productosResp.data.productos);
      setFavoritos(idsFavoritos);
    } catch (error) {
      setError('Error al obtener productos o favoritos');
      console.error("❌ Error en fetchInventoryAndFavorites:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (token && userId) fetchInventoryAndFavorites();
  }, [orderBy, orderDirection, searchTerm, token, userId]);

  // Cuando necesites recargar:



  // 🚨 Bloquea la navegación al cerrar la pestaña o recargar la página
  useBeforeunload((event) => {
    if (editProductRef.current?.hasUnsavedChanges) {
      event.preventDefault();
    }
  });

  // 🚨 Bloquea el botón atrás del navegador
  useEffect(() => {
    const handlePopState = () => {
      if (editProductRef.current?.hasUnsavedChanges) {
        const confirmExit = window.confirm("Tienes cambios sin guardar. ¿Seguro que quieres salir?");
        if (!confirmExit) {
          navigate(location.pathname, { replace: true });
        }
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, location]);

  const handleEditProduct = (productId) => {
    if (editProductRef.current?.hasUnsavedChanges) {
      const confirmExit = window.confirm("Tienes cambios sin guardar. ¿Seguro que quieres salir?");
      if (!confirmExit) return;
    }

    setSelectedProductId(productId);

    setTimeout(() => {
      editContainerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 0);
  };

  const handleCloseEdit = () => {
    if (editProductRef.current?.hasUnsavedChanges) {
      const confirmExit = window.confirm("Tienes cambios sin guardar. ¿Seguro que quieres salir?");
      if (!confirmExit) return;
    }

    setSelectedProductId(null);
  };


  // Detectamos el scroll utilizando el hook useScrollTrigger
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1800) { // Mostrar la flecha cuando el scroll haya pasado los 300px
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Usando el método nativo del navegador para el desplazamiento
  };

  const handleDelete = async (productId) => {
    // Confirmación antes de eliminar
    const confirmed = window.confirm('¿Estás seguro de que deseas eliminar este producto?');

    if (confirmed) {
      try {
        // Llamada al backend para eliminar el producto
        const response = await axios.delete(
          `${import.meta.env.VITE_API_URL}/productos/admin/${productId}`,
          {
            headers: { 'x-auth-token': token },
          }
        );
        alert('Producto eliminado exitosamente');
        reloadInventory();
      } catch (error) {
        console.error('Error al eliminar el producto:', error);
        alert('Hubo un error al eliminar el producto');
      }
    }
  };




  useEffect(() => {
    if (showScrollToTop) {
      gsap.to('.scroll-to-top-btn', { opacity: 1, scale: 1, duration: 0.3 });
    } else {
      gsap.to('.scroll-to-top-btn', { opacity: 0, scale: 0.5, duration: 0.3 });
    }
  }, [showScrollToTop]);


  const reloadInventory = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/productos/admin`,
        {
          params: { orderBy, orderDirection },
          headers: { 'x-auth-token': token },
        }
      );

      setInventory(response.data.productos);
    } catch (error) {
      setError('Error al obtener los productos');
    } finally {
      setLoading(false);
    }
  };
  const toggleFavorito = async (productoId) => {
    const esFavorito = favoritos.includes(productoId);
    try {
      if (esFavorito) {
        await axios.delete(`${import.meta.env.VITE_API_URL}/favoritos`, {
          headers: { "x-auth-token": token },
          data: { user_id: userId, producto_id: productoId },
        });
      } else {
        await axios.post(
          `${import.meta.env.VITE_API_URL}/favoritos`,
          { user_id: userId, producto_id: productoId },
          { headers: { "x-auth-token": token } }
        );
      }
      // Recargar favoritos (y productos si querés)
      await fetchInventoryAndFavorites();
    } catch (error) {
      console.error("Error actualizando favoritos", error);
      alert("Hubo un error al actualizar favoritos");
    }
  };

  const productosFiltrados = inventory
    .filter(prod =>
      prod.nombre_producto.toLowerCase().includes(searchTerm.toLowerCase()) ||
      prod.codigo_barras?.some(bar => bar.codigo.toLowerCase().includes(searchTerm.toLowerCase()))
    )
    .filter(prod => !mostrarSoloFavoritos || favoritos.includes(prod.id));


  return (
    <div className='text-center flex flex-col align-middle items-center p-3'>
      <div className="flex flex-col space-y-4 p-5 bg-gray-50 rounded-lg shadow-md border border-gray-200">
        <h1 className="text-primary">Gestión de Inventario</h1>
        <button
          onClick={() => setMostrarSoloFavoritos(prev => !prev)}
          className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded shadow mb-4"
        >
          {mostrarSoloFavoritos ? "Ver todos los productos" : "Ver solo favoritos"}
        </button>

        <div className="grid grid-cols-1 py-5 md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <label htmlFor="searchTerm" className="mb-1 text-sm font-medium text-gray-600">
              Término de búsqueda:
            </label>
            <input
              autoFocus
              id="searchTerm"
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Ej: ref123 o nombre"
              className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-500"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="orderBy" className="mb-1 text-sm font-medium text-gray-600">
              Ordenar por:
            </label>
            <select
              id="orderBy"
              value={orderBy}
              onChange={(e) => setOrderBy(e.target.value)}
              className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-500"
            >
              <option value="createdAt">Fecha de creación</option>
              <option value="updatedAt">Última actualización</option>
            </select>
          </div>

          <div className="flex flex-col">
            <label htmlFor="orderDirection" className="mb-1 text-sm font-medium text-gray-600">
              Dirección:
            </label>
            <select
              id="orderDirection"
              value={orderDirection}
              onChange={(e) => setOrderDirection(e.target.value)}
              className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-500"
            >
              <option value="asc">Ascendente</option>
              <option value="desc">Descendente</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex items-start justify-center min-h-screen bg-gray-100 p-4">
        <div className="bg-white shadow-lg rounded-lg w-full max-w-6xl flex flex-col lg:flex-row">
          <div className={`w-full ${selectedProductId ? 'lg:w-2/5' : 'w-full'} p-8`}>
            <h2 className="text-xl font-semibold mb-4">Inventario Actual</h2>

            {loading && <p className="text-center text-gray-500">Cargando inventario...</p>}
            {error && <p className="text-center text-red-500">Error: {error}</p>}

            {!loading && !error && inventory.length > 0 ? (
              <ul className="space-y-4">
                {productosFiltrados.map((product) => {
                  const esFavorito = favoritos.includes(product.id);

                  return (
                    <li 
                      key={product.id}
                      className="border border-gray-200 bg-white rounded-xl p-5 shadow hover:shadow-lg transition-shadow duration-300"
                    >
                      {/* Título y favorito */}
                      <div className="flex items-center justify-between mb-3">
                        <h3 className="text-xl font-semibold text-gray-800 flex-1 truncate">
                          {product.nombre_producto}
                        </h3>
                        <button
                          onClick={() => toggleFavorito(product.id)}
                          title={esFavorito ? 'Quitar de favoritos' : 'Agregar a favoritos'}
                          className={`ml-3 transition-colors duration-200 ${esFavorito ? 'text-red-500' : 'text-gray-400'
                            } hover:text-red-600`}
                        >
                          {esFavorito ? <FaHeart size={22} /> : <FaRegHeart size={22} />}
                        </button>
                      </div>


                      {/* Datos */}
                      <div className="space-y-2 mb-4 text-sm text-gray-700">
                        <p className={`${product.codigo_barras?.length ? '' : 'text-red-500 font-medium'}`}>
                          <span className="font-semibold">Plug asociado:</span>{' '}
                          {product.codigo_barras?.map((bar) => bar.codigo).join(', ') || 'N/A'}
                        </p>
                        <p>
                          <span className="font-semibold">Stock:</span> {product.stock_unidades}
                        </p>
                      </div>

                      {/* Acciones */}
                      <div className="flex gap-4 justify-between mt-4">
                        <button
                          onClick={() => handleEditProduct(product.id)}
                          className="w-full bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                          Editar
                        </button>
                        <button
                          onClick={() => handleDelete(product.id)}
                          className="w-full flex items-center justify-center gap-1 bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                        >
                          <FaTrashAlt /> Eliminar
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>


            ) : (
              !loading && <div className="flex  flex-col justify-center items-center">
                <p className='text-center text-gray-500'>No hay productos encontrados</p>
                <Link to={`/crear-producto?plug=${encodeURI(searchTerm)}`} className='text-blue-500 flex text-center gap-1 hover:underline'>Crear producto con plug:<p className='text-black'>{searchTerm}</p></Link>
                <Link
                  to={`/crear-producto?name=${encodeURIComponent(searchTerm)}`}
                  className="text-blue-500 flex text-center gap-1 hover:underline"
                >
                  Crear producto con Nombre: <span className="text-black">{searchTerm}</span>
                </Link>
              </div>
            )}
          </div>

          {selectedProductId && (
            <div
              ref={editContainerRef}
              className="bg-gray-50 border-l border-gray-300 px-4 h-full max-h-screen overflow-y-auto lg:w-3/5"
            >
              <CompEditProduct
                productId={selectedProductId}
                onSave={() => {
                  reloadInventory();
                  editProductRef.current.hasUnsavedChanges = false;
                }}
                handleCloseEdit={handleCloseEdit}
                ref={editProductRef}
              />
            </div>
          )}
        </div>
      </div>
      {showScrollToTop && (
        <button
          onClick={handleScrollToTop}
          className=" scroll-to-top-btn  fixed bottom-4 right-4 bg-blue-500 text-white p-2 rounded-full  hover:bg-blue-700"
        >
          <FaArrowUp />
        </button>
      )}
    </div>
  );
};

export default CompInventario;
